import {useEffect, useState} from 'react';

import {useI18n} from '@udemy/i18n';
import {udApi} from '@udemy/ud-api';

export interface CartMessage {
    title: string;
    subtitle: string;
}

export const useFetchCartMessageNotice = () => {
    const {gettext} = useI18n();
    const [isCartMessageLoading, setIsCartMessageLoading] = useState(true);
    const [cartMessage, setCartMessage] = useState<{data: CartMessage} | undefined>(undefined);

    useEffect(() => {
        const fetchCartMessage = async () => {
            try {
                setIsCartMessageLoading(true);
                const searchParams = new URLSearchParams(window.location.search);
                const params = Object.fromEntries(searchParams.entries());

                const response = await udApi.get(`/notices/me/`, {
                    params: {
                        type: 'cart_message',
                        ...params,
                    },
                });
                setCartMessage(response.data.results);
                setIsCartMessageLoading(false);
            } catch (error) {
                setIsCartMessageLoading(false);
            }
        };

        fetchCartMessage();
    }, [gettext]);

    return {
        cartMessage,
        isCartMessageLoading,
    };
};
